// extracted by mini-css-extract-plugin
export var Logo = "style-module--Logo--d0fca";
export var LogoImage = "style-module--LogoImage--923ae";